<template>
  <div class="col-1 py-0 d-sm-none">
    <a class="collapsed" @click="openSidebar()" style="cursor: pointer;">
      <i class="fas fa-bars fa-2x"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "SidebarOpener",

  methods: {
    openSidebar() {
      SidebarEventBus.$emit("show");
    }
  }
};
</script>